
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"nonzero","fill":"none"}},[_c('path',{attrs:{"d":"M21.981 12.445c0-.692-.056-1.387-.175-2.067h-9.597v3.917h5.496a4.71 4.71 0 01-2.034 3.092v2.542h3.279c1.925-1.772 3.031-4.389 3.031-7.484z","fill":"#4285F4"}}),_c('path',{attrs:{"d":"M12.21 22.385c2.743 0 5.057-.9 6.743-2.456l-3.278-2.542c-.912.62-2.09.972-3.462.972-2.654 0-4.905-1.79-5.712-4.198H3.118v2.62a10.175 10.175 0 009.091 5.604z","fill":"#34A853"}}),_c('path',{attrs:{"d":"M6.497 14.16a6.094 6.094 0 010-3.895v-2.62h-3.38a10.183 10.183 0 000 9.136l3.38-2.62z","fill":"#FBBC04"}}),_c('path',{attrs:{"d":"M12.21 6.064a5.529 5.529 0 013.902 1.525l2.905-2.905a9.778 9.778 0 00-6.808-2.647 10.172 10.172 0 00-9.091 5.608l3.38 2.62c.803-2.41 3.057-4.201 5.711-4.201z","fill":"#EA4335"}})])])
          )
        }
      }
    